import { ArchivedCommittees } from "./ArchivedCommittees";

export default ArchivedCommittees;
